let counter = 0;

/**
 * Gera um id único e estável para itens criados em runtime (módulos, vínculos).
 *
 * Usa o sufixo `_u<n>` para não colidir com os ids do seed mockado, e um contador
 * único compartilhado por toda a feature (evita colisões entre hooks distintos).
 *
 * @param prefix - Prefixo semântico do id (ex.: `'m'`, `'a'`).
 */
export function nextId(prefix: string): string {
  return `${prefix}_u${++counter}`;
}
